import Section from '@pelckmans/elementis/components/section';
import List from '@pelckmans/elementis/components/list';
import { useTranslation } from 'react-i18next';
import { isScorableMedialink, Medialink } from '../../../../../api/medialink';
import LoadingState from '../../../../../shared-components/LoadingState';
import MedialinkListItem from '../MedialinkListItem';
import MaterialPills from '../../../toc/components/MaterialPills';
import { ANALYTICS_EVENT_SUBLOCATIONS } from '../../../../../constants/analyticsEvents';

interface Props {
  medialinks?: Medialink[];
  getMedialinksForExerciseCategory: () => Promise<void>;
}

function MaterialSection({ medialinks, getMedialinksForExerciseCategory }: Props) {
  const { t } = useTranslation();

  return (
    <Section title={t('PAGES.VEM.MATERIAL_SECTION.TITLE')}>
      {medialinks === undefined && (
        <LoadingState variant="list" aria-label={t(`PAGES.VEM.MATERIAL_SECTION.LOADING.A11Y_LABEL`)} />
      )}
      {medialinks && (
        <List>
          {medialinks.map(m => (
            <MedialinkListItem
              key={m.id}
              medialink={m}
              onCloseCallback={getMedialinksForExerciseCategory}
              scorable={isScorableMedialink(m)}
              subLocationId={ANALYTICS_EVENT_SUBLOCATIONS.PORTAAL_VIRTUAL_EXERCISE_MODULE_EXERCISE_MATERIAL}
              pills={
                <MaterialPills
                  key="material-pills"
                  isAssignment={m.assignments.length > 0}
                  isShared={m.shares.length > 0}
                  isStudent={m.group === 'student'}
                  isTeacher={m.group === 'teacher'}
                  isAdaptive={m.assessmentQExercise?.isAdaptive}
                  isOnTheFly={m.assessmentQExercise?.isOnTheFly}
                />
              }
            />
          ))}
        </List>
      )}
    </Section>
  );
}

export default MaterialSection;
